define('services/storage',[],
    function (app, dialog) {
        var me = function () {};

        me.storage = localStorage;

        me.set = function (key, value) {
            if (nostorage()) return;

            me.storage.setItem(key, value);
        };
        me.get = function (key) {
            if (nostorage()) return null;

            return me.storage.getItem(key);
        };
        me.setObject = function (key, value) {
            me.set(key, JSON.stringify(value));
        };
        me.getObject = function (key) {
            var s = me.get(key);
            
            if (s === 'undefined')
                return null;
            
            return JSON.parse(s);
        };
        me.remove = function (key) {
            if (nostorage()) return;

            me.storage.removeItem(key);
        };
        me.isSupported = function () {
            return !nostorage();
        };

        me.session = function () {
            var session = new me();

            session.storage = sessionStorage;

            return session;
        };

        return me;

        function nostorage() {
            if (typeof (Storage) === 'undefined') {
                system.log('no web storage support');

                return true;
            } else {
                return false;                
            }
        }
    }
);
